import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/feature/ArticleCard';
import FeaturedSlider from './components/FeaturedSlider';
import CategoryNav from './components/CategoryNav';
import {
  articles,
  getHotArticles,
  getLatestArticles,
  categories,
  getFeaturedArticles,
} from '@/mocks/articles';
import { useSEOScript } from '@/hooks/useSEOScript';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Home() {
  const featuredArticles = getFeaturedArticles(4);
  const hotArticles = getHotArticles(6);
  const latestArticles = getLatestArticles(9);

  usePageMeta(
    '最新体育资讯',
    '乐鱼体育新闻资讯站，为您提供最新、最全的体育新闻资讯，涵盖足球、篮球、综合格斗等热门赛事动态，实时比分、赛事分析、球员动态一网打尽，是体育爱好者的首选资讯平台。'
  );

  useSEOScript({
    type: 'WebPage',
    data: {
      name: '乐鱼体育新闻资讯站 - 首页',
      description: '乐鱼体育新闻资讯站，为您提供最新、最全的体育新闻资讯，涵盖足球、篮球、综合格斗等热门赛事动态。',
      url: 'https://www.leyusports.com/',
      isPartOf: {
        '@type': 'WebSite',
        name: '乐鱼体育新闻资讯站',
        url: 'https://www.leyusports.com',
      },
    },
  });

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <FeaturedSlider articles={featuredArticles.length > 0 ? featuredArticles : articles.slice(0, 4)} />

        <CategoryNav />

        <section className="w-full px-4 md:px-6 py-6 md:py-10">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900">热点新闻</h2>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {hotArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-6 md:py-10 bg-background-100/50">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900">最新资讯</h2>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {latestArticles.map((article) => (
              <ArticleCard key={article.id} article={article} variant="horizontal" />
            ))}
          </div>
          <div className="flex justify-center mt-8">
            <Link
              to={`/category/${categories[0].slug}`}
              className="inline-flex items-center gap-1.5 px-6 py-2.5 text-sm font-medium rounded-full border border-primary-300 text-primary-700 hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              查看更多资讯
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900">热门分类</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {categories.map((cat) => {
              const catArticles = articles.filter((a) => a.categorySlug === cat.slug).slice(0, 3);
              return (
                <div key={cat.slug} className="bg-background-50 rounded-xl border border-background-200/70 p-5">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2.5">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100">
                        <i className={`${cat.icon} text-lg text-primary-600 w-5 h-5 flex items-center justify-center`}></i>
                      </div>
                      <h3 className="text-base font-semibold text-foreground-900">{cat.name}</h3>
                    </div>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-xs text-primary-600 hover:text-primary-700 whitespace-nowrap flex items-center gap-0.5"
                    >
                      更多
                      <i className="ri-arrow-right-s-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    </Link>
                  </div>
                  <div className="space-y-3">
                    {catArticles.map((a) => (
                      <Link
                        key={a.id}
                        to={`/article/${a.id}`}
                        className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors line-clamp-2 leading-snug"
                      >
                        {a.title}
                      </Link>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}